import s from './IconContainer.module.css'

type Props = {
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  isHighlighted?: boolean
}

export const IconContainer = ({
  children,
  size = 'md',
  isHighlighted,
}: Props) => {
  return (
    <div
      className={`${s.container} ${s[size]} ${
        isHighlighted ? s.isHighlighted : ''
      }`}
    >
      {children}
    </div>
  )
}
